import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ContenidoComponent} from './contenido.component';
import {HomeComponent} from './Home/Home.component';
import {CambiarPasswordComponent} from './CambiarPassword/CambiarPassword.component';
import {SeguridadService} from '@servicios/Seguridad.service';

const routes: Routes = [
    {
        path: '',
        component: ContenidoComponent,
        children:
            [
                // Base
                {path: 'home', component: HomeComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
                {path: 'cambiarPassword', component: CambiarPasswordComponent, data: {modulo: 'cambiarpassword'}, canActivate: [SeguridadService]},
                {path: 'configuracion', loadChildren: () => import('@contenido/AppContent/configuracion/configuracion.module').then(m => m.ConfiguracionModule), data: {}, canLoad: [SeguridadService]},
                {path: 'configuracionrh', loadChildren: () => import('@contenido/AppContent/configuracionrh/configuracionrh.module').then(m => m.ConfiguracionRHModule), data: {}, canLoad: [SeguridadService]},
                {path: 'planeacion', loadChildren: () => import('@contenido/AppContent/planeacion/planeacion.module').then(m => m.PlaneacionModule), data: {}, canLoad: [SeguridadService]},
                {path: 'evaluacionpendiente', loadChildren: () => import('@contenido/AppContent/evaluacionpendiente/evaluacionpendiente.module').then(m => m.EvaluacionesPendientesModule), data: {}, canLoad: [SeguridadService]},
                {path: 'reporte', loadChildren: () => import('@contenido/AppContent/reporte/reporte.module').then(m => m.ReporteModule), data: {}, canLoad: [SeguridadService]},
                {path: 'acuerdos', loadChildren: () => import('@contenido/AppContent/acuerdo/acuerdo.model').then(m => m.AcuerdoModule), data: {}, canLoad: [SeguridadService]},
                {path: 'encuesta', loadChildren: () => import('@contenido/AppContent/encuesta/encuesta.module').then(m => m.EncuestaModule), data: {}, canLoad: [SeguridadService]},
                {path: '**', redirectTo: 'home', pathMatch: 'full'}
            ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ContenidoRoutingModule {}
